import { render, staticRenderFns } from "./TaxCalculator.vue?vue&type=template&id=56965e93"
import script from "./TaxCalculator.vue?vue&type=script&lang=js"
export * from "./TaxCalculator.vue?vue&type=script&lang=js"
import style0 from "./TaxCalculator.vue?vue&type=style&index=0&id=56965e93&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports